import React, { useState, useEffect, useRef } from 'react'

import * as THREE from 'three'

import useIsFirstRender from './is_first_render.js'
import { gsap } from 'gsap'

let log_container = null

const phone_log = (msg) => {
	if(!log_container){
		log_container = document.createElement('div');
		log_container.classList.add('absolute', 'top-0', 'left-0', 'bg-slate-950/75', 'z-10', 'p-10', 'w-full')
		document.body.appendChild(log_container)
	}
	const h1 = document.createElement('h1')
		h1.textContent = msg
		h1.classList.add('.text-shadow-strong', 'text-white', 'z-10', 'text-4xl')
		log_container.appendChild(h1)
}

const useVantas = ({
	is_active,
	effect, effect_options,
	canvasFadeIn, canvasReady
}) => {
	const [vanta_effect, setVantaEffect] = useState(null)

	const root_ref = useRef(null)
	const canvas_ref = useRef(null)
	const resize_timeout = useRef(null)

	useEffect(()=>{
		const root = root_ref?.current

		if (!vanta_effect && is_active && root) {
			setVantaEffect(effect({
				el: root,
				THREE: THREE,
				mouseControls: false,
				touchControls: false,
				gyroControls: false,
				minHeight: 200,
				minWidth: 200,
				width: '100%',
				height: '100%',
				...effect_options
			}))
		}

		const cleanup = () => {
			if (vanta_effect) {
				vanta_effect.destroy()
				setVantaEffect(null)
			}
		}

		vanta_effect && !is_active && cleanup()

	    return cleanup
	}, [vanta_effect, is_active])

	useEffect(() => {
		const root = root_ref.current
		const canvas = root.querySelector('.vanta-canvas');

		if (vanta_effect && root && canvas) {
			canvas_ref.current = canvas

			if(canvasReady){
				canvasReady(canvas)
			}

			if(canvasFadeIn){
				canvasFadeIn(canvas)
			} else {
				gsap.to(canvas, { opacity: 0.5, duration: 2 })
			}
		}
	}, [vanta_effect, root_ref.current])

	useEffect(()=>{
		const root = root_ref.current
		const canvas = root.querySelector('.vanta-canvas');

		if(!root || !canvas || !vanta_effect){
			return
		}

		const update_size = () =>{
			clearTimeout(resize_timeout.current)

			resize_timeout.current = setTimeout(()=>{
				const delta = Math.max(
					Math.abs(root.offsetWidth - canvas.offsetWidth),
					Math.abs(root.offsetHeight - canvas.offsetHeight)
				)

				if(delta > 1){
					vanta_effect.mouseX = root.offsetWidth / 2
					vanta_effect.mouseY = root.offsetHeight / 2
					vanta_effect.resize()
					// Fix for xOffset and yOffset on HALO
					vanta_effect.initMouse()
				}
			}, 20)
		}

		const resize_observer = new ResizeObserver(update_size)
		resize_observer.observe(root_ref.current)

		return () => {
			clearTimeout(resize_timeout.current)

			resize_observer.disconnect()
		}
	}, [vanta_effect, root_ref, canvas_ref])

	const canvasFadeOut = () => {
		const canvas = canvas_ref.current

		if(canvas){
			gsap.fromTo(canvas, { opacity: canvas.style.opacity } , { opacity: 0, duration: 1 })
		}
	}

	return [root_ref, canvas_ref, canvasFadeOut]
}

export default useVantas

